import { Base } from "../core/base.model";
import { Empleado } from "../empleado/empleado.model";

export class nuevosAlcances {
    // idAlcance: number;
    id_proyecto: string;
    fechaInicio: string;
    fechaFin: string;
    justificacion: string;
    horasTotales: string;
    horasEtc: number;
    presupuestoAutorizado: number;
}